import FiltedBodyCell from '../common/component/FiltedBodyCell';
import TableCellFilted from '../common/componentUI/TableCellFilted';
import { ChipStatus } from '../common/componentUI/commonStyleComponents';
import { convertToFormData } from '../lab-result/utils';
import { teleAppoinmentDispatcher } from '../tele-appointment';
import backroomModuleDispatcher from './action';
import GroupSearch from './component/GroupSearch';
import ModalShowResult from './component/ModalShowResult';
import {
  BACKROOM_MODULE_STATUS_DISPLAY,
  BACKROOM_MODULE_STATUS_COLOR,
  renderColumn,
  renderListAction,
} from './constants';
import { hasResultFile } from './resultFile';
import TableContainer from '@/components/Table/TableContainer';
import { blobUrl, createDownloadableMultiLinks } from '@/helpers';
import customToast from '@/new-components/CustomNotification';
import CustomTooltip2 from '@/new-components/CustomTooltip';
import {
  TableHead,
  TableRow,
  TableCell,
  IconButton,
  Tooltip,
  withStyles,
  Dialog,
} from '@material-ui/core';
import { isEmpty } from 'lodash';
import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

const TableCellSticky = withStyles({
  root: {
    position: 'sticky',
    background: 'white',
    right: 0,
    width: 100,
  },
})(TableCell);

const CustomTooltip = withStyles({
  tooltip: {
    backgroundColor: '#fafafa',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 230,
    padding: '8px 16px',
    fontSize: 14,
    boxShadow: '1px 1px 4px -1px #000000',
  },
})(Tooltip);

const BackroomModule = () => {
  const { list: data, paging } = useSelector((state) => state.backroomModule);

  const [hiddenRows, setHiddenRows] = useState({});
  const [searchKey, setSearchKey] = useState('');
  const [sortOption, setSortOption] = useState({});
  const [selectedItem, setSelectedItem] = useState([]);
  const [listModule, setListModule] = useState([]);

  const [startTime, setStartTime] = useState(moment().startOf('month'));
  const [endTime, setEndTime] = useState(moment().endOf('date'));
  const [backroomStatuses, setBackroomStatuses] = useState([]);
  const [locationIds, setLocationIds] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [typeModal, setTypeModal] = useState('upload');

  const [filterOption, setFilterOption] = useState({
    statuses: backroomStatuses,
    startTime,
    endTime,
  });
  const tableColumn = renderColumn();

  const onResetFilterOps = () => {
    setBackroomStatuses([]);
    setLocationIds([]);
    setStartTime('');
    setEndTime('');
    setFilterOption({
      statuses: [],
      locationIds: [],
      startTime: '',
      endTime: '',
    });
  };
  const onFilterOptionClear = (state, setState, defaultValue) => () => {
    setFilterOption({
      ...filterOption,
      [state]: defaultValue,
    });
    setState(defaultValue);
  };

  const onFilterOptionChange = (state, setState) => (e) => {
    setFilterOption({
      ...filterOption,
      [state]: e.target.value,
    });
    setState(e.target.value);
  };

  const onHandleModal = (type) => {
    setShowModal(true);
    setTypeModal(type);
  };

  const onSubmit = (data, key, callback) => {
    if (!selectedItem) return null;
    const { paxScreeningId, hasIRReport } = selectedItem;
    const { listFiles, defaultDoctor, moduleDoctors, note, byPassTests } = data;

    let formData = new FormData();

    // Group data by moduleId to handle duplicates
    const groupedData = {};
    listFiles.forEach((item) => {
      groupedData[item.moduleId] = item;
    });

    // Add files to FormData, replacing duplicates by moduleId
    Object.values(groupedData).forEach((item) => {
      formData.append(
        'fileResults',
        item.resultFilePath,
        `${item.moduleId}.pdf`
      );
    });

    const hasModuleDoctors = Object.values(moduleDoctors).some(
      (doc) => doc && doc.id
    );

    if (!isEmpty(defaultDoctor?.id)) {
      // Default doctor takes priority, only send ModuleId (no per-module DoctorId)
      formData.append('defaultDoctorId', defaultDoctor.id);
      listModule.forEach((item, index) => {
        formData.append(`assignedDoctors[${index}].ModuleId`, item.moduleId);
      });
    } else if (hasModuleDoctors) {
      // Per-module doctor mode only, no default doctor
      formData.append('defaultDoctorId', '');
      let index = 0;
      listModule.forEach((item) => {
        const doctor = moduleDoctors[item.moduleId];
        formData.append(`assignedDoctors[${index}].ModuleId`, item.moduleId);
        formData.append(`assignedDoctors[${index}].DoctorId`, doctor?.id || '');
        index++;
      });
    }
    if (byPassTests?.length > 0) {
      byPassTests.forEach((item, index) => {
        formData.append(`byPassTests[${index}].ModuleId`, item.moduleId);
        formData.append(
          `byPassTests[${index}].IsReviewRequired`,
          item.isReviewRequired
        );
      });
    }
    formData.append('note', note || '');

    if (key === 'upload') {
      backroomModuleDispatcher.uploadBackroom(
        paxScreeningId,
        formData,
        (isSuccess) => {
          if (isSuccess) {
            setShowModal(false);
            backroomModuleDispatcher.getData(
              searchKey,
              paging,
              filterOption,
              sortOption
            );
          } else {
            // Clear FormData on failure
            for (let key of formData.keys()) {
              formData.delete(key);
            }
          }
          callback && callback(isSuccess);
        }
      );
    } else {
      let holdLinksDownload = [];
      let totalModulesDownload = listModule.filter(hasResultFile).length;
      if (hasIRReport)
        teleAppoinmentDispatcher.downloadIRReport(paxScreeningId);
      else if (!hasIRReport && totalModulesDownload !== 0) {
        listModule.forEach((item) => {
          if (hasResultFile(item)) {
            backroomModuleDispatcher.getLinkDownloadBackroom(
              paxScreeningId,
              item.moduleId,
              (link) => {
                holdLinksDownload.push(blobUrl(link));
                if (holdLinksDownload.length === totalModulesDownload) {
                  createDownloadableMultiLinks(
                    holdLinksDownload,
                    'Modules Result',
                    'pdf'
                  );
                  customToast('success', 'Download modules successs');
                }
              }
            );
          }
        });
      }

      setShowModal(false);
      callback && callback(true);
    }
  };

  const renderDateTime = (row) => {
    let dateFormat, timeFormat;
    const { datetime } = row;

    if (!datetime) return null;

    dateFormat = moment(datetime).format('DD-MM-YYYY');
    timeFormat = moment(datetime).format('LT');
    return `${dateFormat}, ${timeFormat}`;
  };

  const TableCellFiltedWrapper = ({ ...props }) => (
    <TableCellFilted
      {...{
        hiddenRows,
        setHiddenRows,
      }}
      {...props}
    />
  );

  const TableHeader = () => (
    <TableHead>
      <TableRow>
        {tableColumn.map(({ label, stateValue }) =>
          stateValue ? (
            <TableCellFiltedWrapper
              key={stateValue}
              label={label}
              stateValue={stateValue}
              style={{ width: 160 }}
            >
              {label}
            </TableCellFiltedWrapper>
          ) : (
            <TableCellSticky />
          )
        )}
      </TableRow>
    </TableHead>
  );

  const renderTableBody = (row) => {
    const disableDownload = row.hasIRReport || row.hasResultFilePath;
    return (
      <>
        <FiltedBodyCell hidden={hiddenRows.fullname}>
          {row.fullname}
        </FiltedBodyCell>
        <FiltedBodyCell hidden={hiddenRows.identityNumber}>
          {row.identityNumber || ''}
        </FiltedBodyCell>
        <FiltedBodyCell hidden={hiddenRows.datetime}>
          {renderDateTime(row)}
        </FiltedBodyCell>
        <FiltedBodyCell hidden={hiddenRows.backroomStatus}>
          <ChipStatus color={BACKROOM_MODULE_STATUS_COLOR[row.backroomStatus]}>
            {BACKROOM_MODULE_STATUS_DISPLAY[row.backroomStatus]}
          </ChipStatus>
        </FiltedBodyCell>
        <FiltedBodyCell hidden={hiddenRows.note}>
          <CustomTooltip2 content={row.note || '—'} />
        </FiltedBodyCell>

        <TableCellSticky align="right" style={{ padding: 2 }}>
          {renderListAction(
            onHandleModal,
            row.hasRadiologiesProcedure,
            disableDownload
          ).map((action) => {
            const Icon = action.icon;
            return (
              <CustomTooltip title={action.label}>
                <IconButton
                  key={action.key}
                  disabled={action.disabled}
                  onClick={() => {
                    action.onClick();
                    setSelectedItem(row);
                    backroomModuleDispatcher.getBackroomDetails(
                      row.paxScreeningId,
                      (data) => {
                        setListModule(data);
                      }
                    );
                  }}
                >
                  <Icon
                    style={{ color: action.disabled ? '#c7cdd4' : '#8f9ba9' }}
                  />
                </IconButton>
              </CustomTooltip>
            );
          })}
        </TableCellSticky>
      </>
    );
  };

  return (
    <>
      <TableContainer
        fullWidthSearch
        title="Results Upload"
        searchPlaceholder="User Name, NRIC"
        header={TableHeader}
        data={data}
        paging={paging}
        query={(...params) => {
          backroomModuleDispatcher.getData(...params);
        }}
        searchKey={searchKey}
        setSearchKey={setSearchKey}
        filterOption={filterOption}
        sortOption={sortOption}
        renderRow={(row, i) => renderTableBody(row)}
        timeDebounce={1200}
        ToolbarComponent={
          <GroupSearch
            {...{
              onFilterOptionClear,
              onFilterOptionChange,
              filterOption,
              setFilterOption,
              onResetFilterOps,
              backroomStatuses,
              setBackroomStatuses,
              locationIds,
              setLocationIds,
              startTime,
              setStartTime,
              endTime,
              setEndTime,
            }}
          />
        }
      />
      <Dialog
        fullWidth
        maxWidth="sm"
        open={showModal}
        onClose={() => setShowModal(false)}
        disableBackdropClick
      >
        <ModalShowResult
          selectedItem={selectedItem}
          onSubmit={onSubmit}
          listModule={listModule}
          typeModal={typeModal}
          onClose={() => setShowModal(false)}
        />
      </Dialog>
    </>
  );
};

export default BackroomModule;
